import { useDemandStudioContext } from "../../contexts/DemandStudioContext";
import { RenderIf, XButton } from '../index';
import Tooltip from "../ui-control/Tooltip";
import UndoRedoButtons from "./UndoRedoButtons";
import DemandStudioSearchBar from "./DemandStudioSearchBar";
import DemandStudioTipsPopover from "./DemandStudioTipsPopover";
import DemandStudioPreviewDownloadButton from "./DemandStudioPreviewDownloadButton";
import getPreviewButtonState from "./previewButtonState";
import { TOUR_TARGETS } from "../../constants/tourTargets";
const headerRightClasses = "inline-flex items-center gap-4 ml-6";
const headerActionsClasses = "relative inline-flex items-center gap-2";


const DemandStudioToolBar = () => {
    const {
        isPreviewLoading,
        showPreview,
        isSearchBarOpen,
        isTipsOpen,
        tipsAnchorRef,
        handleSave,
        handleTogglePreview,
        handleOpenSearchBar,
        handlePreview,
        toggleTips,
        closeTips,
        isUndoLoading,
        hasUndo,
        hasRedo,
        handleUndo,
        isAnySectionRegenerating,
        isManualEditProcessing
    } = useDemandStudioContext();

    const { isPreviewButtonLoading, previewTooltip } = getPreviewButtonState({
        isPreviewLoading,
        isSuggestedEditRunning: isAnySectionRegenerating,
    });

    return (
        <div className={headerRightClasses}>
            <div className={headerActionsClasses} ref={tipsAnchorRef} data-tour={TOUR_TARGETS.DEMAND_STUDIO_TOOLS}>
                {isSearchBarOpen && !showPreview ? (
                    <DemandStudioSearchBar />
                ) : (
                    <Tooltip title="Search" placement="bottom" leaveDelay={50}>
                        <XButton
                            variant="iconHeader"
                            aria-label="Search"
                            onClick={handleOpenSearchBar}
                        >
                            <i className="fa fa-search" />
                        </XButton>
                    </Tooltip>
                )}
                <UndoRedoButtons
                    isUndoLoading={isUndoLoading}
                    isSuggestedEditRunning={isAnySectionRegenerating}
                    isManualEditProcessing={isManualEditProcessing}
                    hasUndo={hasUndo}
                    hasRedo={hasRedo}
                    handleUndo={handleUndo}
                    variant="iconHeader"
                />

                <Tooltip title="Tips" placement="bottom" leaveDelay={50}>
                    <XButton
                        variant="iconHeader"
                        aria-label="Tips"
                        aria-pressed={isTipsOpen}
                        onClick={toggleTips}
                    >
                        <i className="fa-regular fa-lightbulb" />
                    </XButton>
                </Tooltip>
                <DemandStudioTipsPopover isOpen={isTipsOpen} onClose={closeTips} />
                <RenderIf shouldRender={showPreview}>
                    <Tooltip title="Close Preview" placement="bottom" leaveDelay={50}>
                        <XButton
                            variant="iconHeader"
                            aria-label="Close Preview"
                            onClick={handleTogglePreview}
                        >
                            <i className="fa fa-eye-slash" />
                        </XButton>
                    </Tooltip>
                    <DemandStudioPreviewDownloadButton />
                </RenderIf>
                <RenderIf shouldRender={!showPreview}>
                    <Tooltip
                        title={previewTooltip}
                        placement="bottom"
                        leaveDelay={50}
                    >
                        <XButton
                            variant="iconHeader"
                            aria-label={previewTooltip}
                            data-tour={TOUR_TARGETS.DEMAND_STUDIO_PREVIEW}
                            onClick={handlePreview}
                            disabled={isPreviewButtonLoading}
                        >
                            <i className={isPreviewButtonLoading ? "fa fa-spinner animate-spin" : "fa fa-eye"} />
                        </XButton>
                    </Tooltip>
                </RenderIf>
            </div >
            <XButton
                aria-label="Save and Return"
                data-tour={TOUR_TARGETS.DEMAND_STUDIO_SAVE}
                onClick={handleSave}
            >
                <span>Save and Return</span>
            </XButton>
        </div >
    )
}


export default DemandStudioToolBar;
